<template>
    <div id="app" class="mainDiv">

        <!-- -------------------------------------------------------------------------------- -->
        <!-- --------------------------- Anchor Approaches ----------------------------------- -->
        <!-- -------------------------------------------------------------------------------- -->

        <hr />

        <!-- ------------------------- internal only: click handler function ------------------------ -->

        <span style="color: blue; text-decoration: underline; cursor: pointer;" @click="downloadFile()"><span
                style="color: #DC143C; font-size: larger;">Internal: </span><strong>Works: </strong> Does not pass file
            name</span>

        <br /><br />

        <span @click="downloadFileWithName('demo.txt')"
            style="color: blue; text-decoration: underline; cursor: pointer;"><span
                style="color: #DC143C; font-size: larger;">Internal: </span><strong>Works: </strong> This works passing file
            name (hard coded parameter)</span>

        <br /><br />

        <span @click="downloadFileWithName(fileName_Internal)"
            style="color: blue; text-decoration: underline; cursor: pointer;">
            <span style="color: #DC143C; font-size: larger;">Internal: </span><strong>Works: </strong> {{ textForLink }}</span>

        <br />

        <hr />

        <!-- ------------------------- anchor only ------------------------ -->

        <a target="_blank" href="https://www.jccs.gov/CAAMS/docs/8. SPOT LOA Sample Verified Mar 2018.pdf">CAAMS/docs: 8.
            SPOT LOA Sample Verified Mar 2018.pdf</a> - <span> (<span style="color: red; font-size: larger;">CAAMS
                Internal:</span> Forces Login: <strong>doesn't</strong> work.). 
                <span style="color: #b36b00; font-size: x-larger; font-weight: bold;"> Straight Anchor Tag.</span> 
            </span>

        <br /><br />

        <a target="_blank" href="https://www.jccs.gov/jccscoe/public/documents/userguides/CAAMS_KOCOR_JCXSTraining.pdf">
            <span style="color: #DC143C; font-size: larger;">CAMMS Internal (public): </span><strong>Works: </strong> User
            guide: CAAMS_KOCOR_JCXSTraining.pdf</a>. 
            <span style="color: #b36b00; font-size: x-larger; font-weight: bold;"> Straight Anchor Tag.</span>

        <br /><br />

        <a target="_blank" href="https://www.jccs.gov/jccscoe/3in1/NGUserGuide.pptx">
            3ub1 NGUserGuide.pptx </a>
        <span style="color: #DC143C; font-size: larger;">3in1 Internal: </span><strong>Does not Works </strong>
        <span style="color: #b36b00; font-size: x-larger; font-weight: bold;"> Straight Anchor Tag.</span>

        <hr />

        <!-- ------------------------- non-axios click handler ------------------------ -->

        <span style="color: blue; text-decoration: underline; cursor: pointer;" @click="downloadFileExternal()">
            <span style="color: #DC143C; font-size: larger;">CAAMS (public): </span><strong>Works: </strong>
            Non-Axios (
                <span style="color: #006600; font-size: x-larger; font-weight: bold;">Dynamic controls</span>
                )
        </span>

        <br /><br />

        <span style="color: blue; text-decoration: underline; cursor: pointer;"
            @click="downloadFileExternalWithName(baseUrlExternal, fileNameExternal)">
            <span style="color: #DC143C; font-size: larger;">CAAMS (public): </span><strong>Works: </strong>
            Non-Axios (
                <span style="color: #006600; font-size: x-larger; font-weight: bold;">Dynamic controls pass arguments</span>
                )
        </span>

        <br /><br />

        <span style="color: blue; text-decoration: underline; cursor: pointer;"
            @click="downloadFileExternalWithName(baseURL_Internal, fileName_Internal)">
            <span style="color: #DC143C; font-size: larger;">Internal: </span><strong>Works: </strong>
            Non-Axios (
                <span style="color: #006600; font-size: x-larger; font-weight: bold;">Dynamic controls pass arguments</span>
                )
        </span>
        <br /><br />

        <!-- -------------------------------------------------------------------------------- -->
        <!-- --------------------------- Grid Control --------------------------------------- -->
        <!-- -------------------------------------------------------------------------------- -->

        <hr />

        <div class="gridDiv">

            <ApplicationGrid :GridData="gridTime" :EnablePaging="false" :EnableSearching="true" :EnableSorting="true"
                :HeaderArrays="headerArrays" :LeftRightSlots="leftRightSlots" :CenterGridSlots="centerGridSlots"
                :EnableSettings="true">

                <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->
                <!-- +++++++++++++++ grid slots START +++++++++++++ -->
                <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->

                <!-- ---------------------------------------------------- -->
                <!-- ---------- centerGrid3 (fullDocumentName) ---------- -->
                <!-- ---------------------------------------------------- -->

                <template v-slot:centerGrid3="slotArgs">

                    <div class="activeAgency" :id="'Agency1_d' + slotArgs.itemArg['personDocumentID']" data-tooltip="tooltip"
                        title="Click to open the document" style="width: 100%">

                        <span style="color: blue; text-decoration: underline; cursor: pointer;"
                            @click="downloadFileExternalWithName(baseUrlExternal, fileNameExternal)">
                            {{ slotArgs.itemArg['fullDocumentName'] }}
                        </span>

                    </div>

                </template>

                <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->
                <!-- +++++++++++++++ grid slots END +++++++++++++++ -->
                <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->

            </ApplicationGrid>

        </div>

    </div>
</template>

<script>
import axios from "axios";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue";

//https://www.jccs.gov/CAAMS/docs/8.%20SPOT%20LOA%20Sample%20Verified%20Mar%202018.pdf

export default {
    mounted() {
        //this.downloadFile();
    },

    data() {
        return {
            fileNameExternal: 'CAAMS_KOCOR_JCXSTraining.pdf',
            baseUrlExternal: 'https://www.jccs.gov/jccscoe/public/documents/userguides/',
            fileName_Internal: 'demo.txt',
            customFileName: 'customFileName.txt',
            baseURL_Internal: 'https://localhost:8080/files/',
            textForLink: 'All Properties: passes argument',

            // ------------------ grid support --------------------

            gridTime: { grid: null, time: null },
            personID: 35292,

            headerArrays: [
                { defaultShow: true, rawName: 'personDocumentID', displayName: 'Person Document ID', hoverText: 'Database Record ID' },
                { defaultShow: false, rawName: 'personID', displayName: 'Person ID', hoverText: 'Database Person ID' },
                { defaultShow: false, rawName: 'documentTypeId', displayName: 'Document Type Id', hoverText: 'Database Document ID' },
                { defaultShow: false, rawName: 'documentType', displayName: 'Type', hoverText: 'Document Type' },
                { defaultShow: true, rawName: 'documentId', displayName: 'Document Id', hoverText: 'Database Document ID' },
                { defaultShow: false, rawName: 'documentGuid', displayName: 'Document Guid', hoverText: 'Database Document Guid' },
                { defaultShow: false, rawName: 'documentName', displayName: 'Document Name', hoverText: 'Document Name' },
                { defaultShow: false, rawName: 'documentMimeType', displayName: 'Document document Mime', hoverText: 'Document Mime' },
                { defaultShow: true, rawName: 'fullDocumentName', displayName: 'Document', hoverText: 'Full Document Name' },
                { defaultShow: false, rawName: 'signExpiration', displayName: 'Signed Date', hoverText: 'Signed Expiration Date' },
                { defaultShow: false, rawName: 'documentExpiration', displayName: 'Expiration Date', hoverText: 'Expiration date for document' },
                { defaultShow: false, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Date the record was last updated' },
                { defaultShow: false, rawName: 'lastUpdateEmail', displayName: 'UpdateBy', hoverText: 'The person who last updated the document' },
                { defaultShow: false, rawName: 'acodqcVerifiedDate', displayName: 'ACOD QC Verified Date', hoverText: 'ACOD QC Verified Date' },
                { defaultShow: false, rawName: 'acodqcVerified', displayName: 'ACOD QC Verified', hoverText: 'ACOD QC Verified' },
                { defaultShow: false, rawName: 'lrVerifiedDate', displayName: 'LR Verified Date', hoverText: 'LR Verified Date' },
                { defaultShow: false, rawName: 'lrVerified', displayName: 'LR Verified', hoverText: 'LR Verified' },
                { defaultShow: false, rawName: 'qcVerifiedDate', displayName: 'QC Verified Date', hoverText: 'QC Verified Date' },
                { defaultShow: false, rawName: 'qcVerified', displayName: 'QC Verified', hoverText: 'QC Verified' },
                { defaultShow: false, rawName: 'acodqcSelect', displayName: 'ACOD QC Select', hoverText: 'ACOD QC Select' },
                { defaultShow: false, rawName: 'aalNumber', displayName: 'AAL Number', hoverText: 'AAL Number' },
                { defaultShow: false, rawName: 'permitExpire', displayName: 'Permit Expire', hoverText: 'Permit Expire Date' }
            ],
            centerGridSlots: [
                { slot: 'centerGrid3', field: 'fullDocumentName' },
            ],

        };
    },

    created() {
        this.getGridDataUnique();
    },
    computed: {},
    components: { ApplicationGrid },
    methods: {

        // ----------------------------------------------------------------------
        // --------------------- Data Grid --------------------------------------
        // ----------------------------------------------------------------------

        getGridDataUnique() {
            console.log('## getGridDataUnique: this.$data.personID = ', this.$data.personID);

            axios
                .get("https://localhost:7100/api/PersonDocument/selLatestDocsforPerson/" + this.$data.personID)
                .then((response) => response.data)
                .then((data) => {
                    this.$data.gridTime = { grid: data, time: new Date().getTime() };
                    // console.log('data = ', data);

                });
        },

        // ----------------------------------------------------------------------
        // ----------------------- Axios Download -------------------------------
        // ----------------------------------------------------------------------

        downloadFile() {
            let fileUrl = this.$data.baseURL_Internal + this.$data.fileName_Internal;
            axios({
                url: fileUrl,
                method: 'GET',
                responseType: 'blob',
            }).then((res) => {

                var FileBlobURL = window.URL.createObjectURL(new Blob([res.data]));

                var docUrl = document.createElement('a');

                docUrl.href = FileBlobURL;
                docUrl.setAttribute('download', this.$data.customFileName);

                document.body.appendChild(docUrl);

                docUrl.click();
            });
        },

        downloadFileWithName(xfileName) {
            console.log('xfileName = ', xfileName);
            let fileUrl = this.$data.baseURL_Internal + xfileName;
            axios({
                url: fileUrl,
                method: 'GET',
                responseType: 'blob',
            }).then((res) => {

                var FileBlobURL = window.URL.createObjectURL(new Blob([res.data]));

                var docUrl = document.createElement('a');

                docUrl.href = FileBlobURL;
                docUrl.setAttribute('download', xfileName);

                docUrl.style.display = 'none';

                document.body.appendChild(docUrl);

                docUrl.click();

                document.body.removeChild(docUrl);
            });
        },

        // ----------------------------------------------------------------------
        // --------------------- Non-Axios Download -----------------------------
        // ----------------------------------------------------------------------

        downloadFileExternal() {
            let fileUrl = this.$data.baseUrlExternal + this.$data.fileNameExternal;

            var docUrl = document.createElement('a');

            docUrl.href = fileUrl;
            docUrl.setAttribute('download', this.$data.fileNameExternal);
            docUrl.setAttribute('target', '_blank');

            document.body.appendChild(docUrl);

            docUrl.click();
        },

        downloadFileExternalWithName(baseURL, xfileNamex) {
            let fileUrl = baseURL + xfileNamex;

            var docUrl = document.createElement('a');
            docUrl.style.display = 'none';

            docUrl.href = fileUrl;
            docUrl.setAttribute('download', xfileNamex);
            docUrl.setAttribute('target', '_blank');

            document.body.appendChild(docUrl);

            docUrl.click();

            document.body.removeChild(docUrl);

        },

    },
};
</script>


<style scoped>
.mainDiv {
    text-align: center;
    justify-content: center;
}

.gridDiv {
    display: inline-block;
    width: 50%;
}

</style>